<template>
  <div class="geomap-page">
    <LMap
      ref="map"
      :zoom="zoom"
      :max-bounds="maxBounds"
      :min-zoom="minZoom"
      :max-bounds-viscosity="1.0"
      :center="center"
      :options="{ attributionControl: false}"
      :use-global-leaflet="false"
      class="!h-full outline-none"
    >
      <LTileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        name="OpenStreetMap"
        :no-wrap="true"
      />

      <template v-if="projects">
        <template v-for="project in projects">
          <LMarker
            v-if="project.data?.projectDetails?.location?.latitude && project.data?.projectDetails?.location?.longitude"
            :key="project.id"
            :draggable="true"
            :lat-lng="[project.data.projectDetails.location.latitude, project.data.projectDetails.location.longitude]"
            @click="handleSelectProject(project.id)"
            @dragend="event => handleMarkerDragEnd(event, project)"
          >
            <LTooltip>{{ project.label }}</LTooltip>
          </LMarker>
        </template>
      </template>
    </LMap>

    <AppModal
      v-if="currentProject"
      :title="`${currentProject.id ? 'Edit ' : 'Add a New '}Project`"
      class="[&_.modal-body]:!p-0"
      @close="handleCloseModal"
    >
      <ProjectForm
        :frameworks="frameworks"
        :node="currentProject"
        @submit="handleUpsertNode"
        @cancel="handleCloseModal"
        @delete="handleDeleteNode"
      />
    </AppModal>
  </div>
</template>

<script setup>
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker, LTooltip } from '@vue-leaflet/vue-leaflet';
import { computed, ref } from 'vue';

import { NodeType } from '@/const.js';
import { usePlanStore } from '@/store/index.js';

import { ProjectForm } from '@/components/forms/nodes/index.js';
import { AppModal } from '@/components/modals/index.js';

defineProps({
  frameworks: {
    type: Array,
    default: () => ([]),
  },
});

const maxBounds = [
  [-90, -180],
  [90, 180],
];

const zoom = ref(6);
const minZoom = ref(3);
const center = ref([-29.7, 24.6]);

const currentProject = ref(null);
const planStore = usePlanStore();
const projects = computed(() => planStore.nodes.get({ filter: node => node.type === NodeType.Project }));

const handleDeleteNode = id => {
  planStore.nodes.remove(id);
  handleCloseModal();
};

const refreshNode = node => {
  planStore.nodes.update(node);
};

const handleSelectProject = projectId => {
  currentProject.value = planStore.nodes.get({ filter: node => node.id === projectId })[0];
};

const handleUpsertNode = node => {
  refreshNode(node);
  handleCloseModal();
};

const handleCloseModal = () => {
  currentProject.value = null;
};

const handleMarkerDragEnd = (event, project) => {
  const newPosition = event.target.getLatLng();

  if (!project.data.projectDetails) project.data.projectDetails = { location: {} };
  if (!project.data.projectDetails.location) project.data.projectDetails.location = {};

  project.data.projectDetails.location.latitude = newPosition.lat;
  project.data.projectDetails.location.longitude = newPosition.lng;

  // Update the node in the store
  refreshNode(project);
};
</script>
